import { archiveProjectDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const archiveProjectCallable = getCallable(archiveProjectDefinition);
